import UltMeta, { Meta } from "@/meta/UltMeta/index";

class BannerPos extends UltMeta {
    PURCHASER = new Meta(1, "链云砂石");

    CARRIER = new Meta(4, "链云船务");
}
export const BANNER_POS = new BannerPos();

class BannerType extends UltMeta {
    PRODUCT = new Meta(1, "商品");
    PRODUCT_TYPE = new Meta(2, "砂价");
    WHARF = new Meta(3, "运价");
    AD_PAGE = new Meta(4, "广告页");
    INFORMATION = new Meta(5, "资讯");
    FEATURE_PAGE = new Meta(6, "功能页");
}
export const BANNER_TYPE = new BannerType();
